(function(){

    /*
    * Ottimizzazione per la visualizzazione in "Sticky" delle sezioni interne
    * */
    const els = Array.from(document.querySelectorAll('[data-sticky-smart]'));
    if (!els.length) return;

    let raf = 0;

    const getViewportH = () =>
        (window.visualViewport && window.visualViewport.height)
            ? window.visualViewport.height
            : window.innerHeight;

    const updateOne = (el) => {
        const vh = Math.floor(getViewportH());
        const h  = Math.ceil(el.offsetHeight);

        // top = 0 se sta tutta in viewport, altrimenti negativo
        const top = Math.min(0, vh - h);

        el.style.setProperty('--sticky-top', `${top}px`);
    };

    const updateAll = () => {
        els.forEach(updateOne);
    };

    const schedule = () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateAll);
    };

    // first run
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', schedule, { passive: true });
    } else {
        schedule();
    }

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.addEventListener('load', schedule, { passive: true });

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', schedule, { passive: true });
    }

})();
